import Intercom from "@intercom/messenger-js-sdk";

// Intercom Messenger 应用内深链：帮助中心文章/空间在消息器内展示，不离开应用。
// 只有消息器压根不存在时才回退到 help.vapetm.com 网页（新标签页）。
export const HELP_CENTER = "https://help.vapetm.com/en/";
export const INTERCOM_APP_ID = "kx28g8jk";

// 在应用内打开消息器。消息器还没起来就现场装载并 boot——
// 客服入口绝不能把用户丢到新的浏览器窗口。
// 只在缺失时 boot：对已经启动的消息器重复 boot 会重置会话。
//
// 用 showNewMessage 而不是 show：消息器处于 lightweight 模式时（只渲染了
// 启动器、完整应用还没加载），show() 会被接受但什么也不做——实测调用后
// 30 秒都不会出现 intercom-container。showNewMessage 能真正打开。
export const openMessenger = settings => {
  if (!window.Intercom) {
    Intercom(settings);
    if (window.Intercom) {
      window.Intercom("boot", settings);
    }
  }
  if (window.Intercom) {
    window.Intercom("showNewMessage", "");
    return true;
  }
  return false;
};

// 「帮助与支持」抽屉里的“在线聊天”。新版界面隐藏了右下角气泡
// （hide_default_launcher），所以这里是聊天的唯一入口。
// 用 show() 打开消息器首页（不是空白的新消息）。以前隐藏气泡时 show()
// 偶尔什么都不做（消息器还是 lightweight 模式），所以 5 秒内没看到消息器
// 就把气泡放回来并改用 showNewMessage，保证用户至少有一条路能聊上。
let chatShown = false;
let showHooked = false;
const messengerOpen = () =>
  chatShown || !!document.querySelector('iframe[name="intercom-messenger-frame"]');

export const openChat = () => {
  if (!window.Intercom) {
    return false;
  }
  if (!showHooked) {
    window.Intercom("onShow", () => (chatShown = true));
    window.Intercom("onHide", () => (chatShown = false));
    showHooked = true;
  }
  window.Intercom("show");
  setTimeout(() => {
    if (!messengerOpen() && window.Intercom) {
      window.Intercom("update", { hide_default_launcher: false });
      window.Intercom("showNewMessage", "");
    }
  }, 5000);
  return true;
};

// call: 触发消息器的函数；onBlocked: 消息器不可用时的回退
//
// 这里刻意不做"打开成功"的校验。之前用 onShow 回调加超时判断，只要没在
// 2/6 秒内收到 onShow 就弹帮助中心网页——而 onShow 在下面这些正常情况下
// 都不会触发：消息器已经是打开状态、冷启动渲染较慢、回调被后续的 boot 清掉。
// 结果就是消息器明明正常打开了，还额外弹一个浏览器窗口。
// 消息器能不能打开由 Intercom 自己负责，这里只负责调用。
export const intercomDeepLink = (call, onBlocked) => {
  if (!window.Intercom) {
    if (onBlocked) {
      onBlocked();
    }
    return;
  }
  try {
    call();
  } catch (e) {
    if (onBlocked) {
      onBlocked();
    }
  }
};

// 在消息器内打开指定文章（Intercom Articles 数字 ID）
export const showArticle = (articleId, fallbackUrl) =>
  intercomDeepLink(
    () => window.Intercom("showArticle", articleId),
    () => window.open(fallbackUrl || HELP_CENTER, "_blank", "noopener")
  );

// 在消息器内打开帮助空间（全部指南/集合）
export const showHelpSpace = () =>
  intercomDeepLink(
    () => window.Intercom("showSpace", "help"),
    () => window.open(HELP_CENTER, "_blank", "noopener")
  );
